module.exports = __webpack_public_path__ + "img/pantalla-7-1.e475b178.png";